import React from 'react';
export function FAQ() {
  return <section className="mb-24" data-id="element-111">
      <h2 className="text-[28px] sm:text-[32px] md:text-[36px] font-semibold text-[#1B2951] mb-8 leading-tight font-['Playfair_Display']" data-id="element-112">
        Your Questions, Answered
      </h2>
      <div className="space-y-6" data-id="element-113">
        <div className="bg-white rounded-lg shadow-md p-6 border border-[#7F8C8D]/10 hover:shadow-lg transition-all duration-300" data-id="element-114">
          <h3 className="text-lg font-semibold text-[#1B2951] mb-3 font-['Poppins']" data-id="element-115">
            Q: How is this different from regular collagen?
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-116">
            A: Regular collagen only provides structure (bricks). Our formula
            includes CERAMOSIDES™ which acts as mortar, locking in benefits and
            speeding results from 90 days to just 15.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border border-[#7F8C8D]/10 hover:shadow-lg transition-all duration-300" data-id="element-117">
          <h3 className="text-lg font-semibold text-[#1B2951] mb-3 font-['Poppins']" data-id="element-118">
            Q: Why does it work in 15 days?
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-119">
            A: CERAMOSIDES™ strengthens your skin barrier immediately, allowing
            collagen to work more efficiently. Clinical studies show visible
            improvements in just 2 weeks.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border border-[#7F8C8D]/10 hover:shadow-lg transition-all duration-300" data-id="element-120">
          <h3 className="text-lg font-semibold text-[#1B2951] mb-3 font-['Poppins']" data-id="element-121">
            Q: Is it suitable for vegetarians?
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-122">
            A: The marine collagen is from fish, but CERAMOSIDES™ is
            plant-based (wheat extract). We're working on a fully vegetarian
            version.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 border border-[#7F8C8D]/10 hover:shadow-lg transition-all duration-300" data-id="element-123">
          <h3 className="text-lg font-semibold text-[#1B2951] mb-3 font-['Poppins']" data-id="element-124">
            Q: Can men use this?
          </h3>
          <p className="text-[#2C3E50] font-['Inter']" data-id="element-125">
            A: Absolutely! Clinical studies included 95 men over 35 who reported
            improvements in skin hydration, hair growth, and even beard density.
          </p>
        </div>
      </div>
    </section>;
}